var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("bk-input", {
        attrs: {
          label: _vm.$t("USERNAME.PLACEHOLDER"),
          icon: "person",
          "helper-text": _vm.$t(_vm.state),
          value: _vm.username,
          valid: _vm.valid,
          pristine: _vm.pristine || _vm.loading,
          disabled: _vm.disabled,
          "watch-value": true,
          id: _vm.id,
          loading: _vm.loading,
          "max-length": 15,
          "allow-hotjar-recording": _vm.allowHotjarRecording
        },
        on: { input: _vm.change }
      }),
      _vm._v(" "),
      _vm.suggestions.length
        ? _c(
            "div",
            { staticClass: "bk-username__suggestions" },
            _vm._l(_vm.suggestions, function(suggestion) {
              return _c(
                "p",
                {
                  staticClass: "bk-username__suggestions__item",
                  on: {
                    click: function($event) {
                      return _vm.clickSuggestion(suggestion)
                    }
                  }
                },
                [_vm._v(_vm._s(suggestion))]
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }